import { Link, useParams } from "react-router-dom";

import { useGetQuestionBankSubjectDetailsQuery } from "../../slices/questionBankSubjectApiSlice";

const QuestionBankSubjectDetailsScreen = () => {
  const { id } = useParams();

  const {
    data: subject,
    isLoading,
    error,
  } = useGetQuestionBankSubjectDetailsQuery(id);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <Link
          to="/question-bank-subjects"
          className="inline-flex items-center gap-2 mb-6 rounded-xl bg-white px-4 py-2 text-blue-600 shadow hover:bg-blue-50 transition"
        >
          ← Back to Question Bank Subjects
        </Link>

        {/* Loading */}
        {isLoading && (
          <div className="rounded-xl bg-blue-100 p-4 text-center text-blue-700">
            Loading question bank subject...
          </div>
        )}

        {/* Error */}
        {error && (
          <div className="rounded-xl bg-red-100 p-4 text-center text-red-700">
            {error?.data?.message ||
              error?.error ||
              "Failed to load question bank subject"}
          </div>
        )}

        {/* Details */}
        {!isLoading && !error && subject && (
          <div className="overflow-hidden rounded-3xl border border-white/30 bg-white/80 shadow-2xl backdrop-blur-lg">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-8 text-white">
              <h1 className="text-3xl font-bold">{subject.name}</h1>

              <p className="mt-2 text-blue-100">
                Question Bank Subject Details
              </p>
            </div>

            {/* Body */}
            <div className="space-y-8 p-8">
              <div className="grid gap-6 md:grid-cols-2">
                {/* Subject Name */}
                <div>
                  <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                    Subject Name
                  </h2>

                  <p className="text-lg font-semibold text-gray-800">
                    {subject.name}
                  </p>
                </div>

                {/* Category */}
                <div>
                  <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                    Category
                  </h2>

                  <span className="inline-flex rounded-full bg-indigo-100 px-4 py-2 text-sm font-semibold text-indigo-700">
                    {subject.category}
                  </span>
                </div>

                {/* Status */}
                <div>
                  <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                    Status
                  </h2>

                  <span
                    className={`inline-flex rounded-full px-4 py-2 text-sm font-semibold ${
                      subject.isActive
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {subject.isActive ? "Active" : "Inactive"}
                  </span>
                </div>

                {/* Created By */}
                <div>
                  <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                    Created By
                  </h2>

                  <p className="font-semibold text-gray-800">
                    {subject.createdBy?.name || "-"}
                  </p>

                  <p className="text-sm text-gray-500">
                    {subject.createdBy?.phone || ""}
                  </p>
                </div>
              </div>

              {/* Description */}
              <div>
                <h2 className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
                  Description
                </h2>

                <div className="rounded-2xl border bg-gray-50 p-5 leading-7 text-gray-700">
                  {subject.description ? (
                    subject.description
                  ) : (
                    <span className="italic text-gray-400">
                      No description provided.
                    </span>
                  )}
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="flex flex-col gap-4 pt-4 sm:flex-row">
                <Link
                  to={`/question-bank-subjects/${subject._id}/edit`}
                  className="flex-1 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 py-3 text-center font-semibold text-white shadow-lg transition hover:from-blue-700 hover:to-indigo-700"
                >
                  Edit Subject
                </Link>

                <Link
                  to="/question-bank-subjects"
                  className="flex-1 rounded-xl border border-gray-300 bg-white py-3 text-center font-semibold text-gray-700 transition hover:bg-gray-100"
                >
                  Back to List
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionBankSubjectDetailsScreen;
